import formatBase from 'date-fns/format/index.js';
import distanceBase from 'date-fns/formatDistanceToNow/index.js';
import strictDistanceBase from 'date-fns/formatDistanceStrict/index.js';
import th from 'date-fns/locale/th/index.js';
import enUS from 'date-fns/locale/en-US/index.js';
import { shallowRef } from 'vue';

const activeLocale = shallowRef(
  typeof window !== 'undefined' &&
    window.chatwootConfig?.selectedLocale === 'th'
    ? th
    : enUS
);

export const setDateLocale = locale => {
  activeLocale.value = locale?.startsWith('th') ? th : enUS;
};
export const getDateLocale = () => activeLocale.value;
const optionsWithLocale = options => ({
  locale: activeLocale.value,
  ...options,
});
export const format = (date, pattern, options = {}) =>
  formatBase(date, pattern, optionsWithLocale(options));
export const formatDistanceToNow = (date, options = {}) =>
  distanceBase(date, optionsWithLocale(options));
export const formatDistanceStrict = (from, to, options = {}) =>
  strictDistanceBase(from, to, optionsWithLocale(options));
